import React from "react";
import WaveText from "../WaveText";

export default function FourOpinionsGeneratorPanel({
  showFourOpinionsGenerator, generatedFourOpinions, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showEssentialVocabularyGenerator,
  showLeadInActivitiesGenerator, showCommunicativeSituationsGenerator,
  fourOpinionsInput, setFourOpinionsInput, fourOpinionsLevel, setFourOpinionsLevel,
  fourOpinionsCount, setFourOpinionsCount, fourOpinionsLoading, handleScrollInDropdown,
  handleFourOpinionsGenerate, handleFourOpinionsInsert, handleFourOpinionsCancel,
}) {
  if (!((showFourOpinionsGenerator || generatedFourOpinions) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showCommunicativeSituationsGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform: 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleFourOpinionsCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate Four Opinions</span>
      </div>

      <textarea
        value={fourOpinionsInput}
        onChange={e => setFourOpinionsInput(e.target.value)}
        placeholder="Enter the topic for opinions..."
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      <div style={{ display: 'flex', gap: 12, marginBottom: 8, flexWrap: 'wrap' }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
          CEFR Level:
          <select
            value={fourOpinionsLevel}
            onChange={e => setFourOpinionsLevel(e.target.value)}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            <option value="A1">A1 - Beginner</option>
            <option value="A2">A2 - Elementary</option>
            <option value="B1">B1 - Intermediate</option>
            <option value="B2">B2 - Upper Intermediate</option>
            <option value="C1">C1 - Advanced</option>
            <option value="C2">C2 - Mastery</option>
          </select>
        </label>

        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
          Number of Opinions:
          <select
            value={fourOpinionsCount}
            onChange={e => setFourOpinionsCount(parseInt(e.target.value))}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            <option value={2}>2 opinions</option>
            <option value={3}>3 opinions</option>
            <option value={4}>4 opinions</option>
            <option value={5}>5 opinions</option>
            <option value={6}>6 opinions</option>
            <option value={7}>7 opinions</option>
            <option value={8}>8 opinions</option>
          </select>
        </label>
      </div>

      <button
        onClick={handleFourOpinionsGenerate}
        disabled={fourOpinionsLoading || !fourOpinionsInput.trim()}
        className={fourOpinionsLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: fourOpinionsLoading || !fourOpinionsInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: fourOpinionsLoading || !fourOpinionsInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: fourOpinionsLoading || !fourOpinionsInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {fourOpinionsLoading ? <WaveText /> : 'Do the magic!'}
      </button>

      {generatedFourOpinions && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: Four Opinions
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            Level: {fourOpinionsLevel} • {generatedFourOpinions.opinions?.length || 0} opinions ready
          </div>

          <div style={{
            maxHeight: '200px',
            overflowY: 'auto',
            marginBottom: 12,
            padding: '8px',
            background: '#fff',
            borderRadius: '6px',
            border: '1px solid #e0e0e0'
          }}
          onWheel={handleScrollInDropdown}>
            {generatedFourOpinions.opinions?.map((opinion, index) => (
              <div key={index} style={{
                padding: '8px 0',
                borderBottom: index < (generatedFourOpinions.opinions?.length || 0) - 1 ? '1px solid #f0f0f0' : 'none',
                fontSize: '13px'
              }}>
                <div style={{ fontWeight: 600, color: '#22223b', marginBottom: '2px' }}>
                  {opinion.name || `Person ${index + 1}`}
                </div>
                <div style={{ color: '#6c757d', fontSize: '12px' }}>
                  {opinion.opinion || 'No opinion provided'}
                </div>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleFourOpinionsInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
